import * as React from "react";
import {
  ImageField,
  Create,
  TextInput,
  ImageInput,
  BooleanInput,
  SelectInput,
  NumberInput,
} from "react-admin";
import { SimpleForm } from "../common/SimpleForm";
import { IMAGE_MAX_SIZE } from "../constants/FileConstants";
import { validateOrder, validateRequired } from "../utils/Validations";
import PolygonMapField from "./PolygonMap/PolygonMapField";
import { getCountries } from "../enums/Countries";

const RegionCreate = () => (
  <Create title="Crear Región" mutationMode="pessimistic">
    <SimpleForm>
      <TextInput source="name" label="Nombre" validate={validateRequired} />
      <ImageInput
        source="image"
        label="Imagen"
        accept={{
          "image/*": [],
        }}
        validate={validateRequired}
        maxSize={IMAGE_MAX_SIZE}
      >
        <ImageField source="src" title="Imagen" />
      </ImageInput>
      <PolygonMapField creating={true} />
      <SelectInput
        label="País"
        source="country"
        choices={getCountries()}
        validate={validateRequired}
      />
      <NumberInput
        source="order"
        label="Orden"
        min={1}
        validate={validateOrder}
        onWheel={(e) => e.target.blur()}
      />
      <BooleanInput
        source="hasDiscounts"
        label="Descuentos"
        defaultValue={true}
      />
      <BooleanInput source="visible" label="Visible" defaultValue={true} />
      <BooleanInput source="active" label="Activo" defaultValue={true} />
    </SimpleForm>
  </Create>
);

export default RegionCreate;
